import { render, staticRenderFns } from "./ChangePasswordNew.vue?vue&type=template&id=030a12fc&scoped=true"
import script from "./ChangePasswordNew.vue?vue&type=script&lang=js"
export * from "./ChangePasswordNew.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordNew.vue?vue&type=style&index=0&id=030a12fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030a12fc",
  null
  
)

export default component.exports